import { Component, OnInit, Output, EventEmitter, Renderer2 } from '@angular/core';
import templateString from './taskVariantGroupChangeOrder.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString, host: {'forUniqueComponentId': 'dasfasfafennenenn'}
})
export class TaskVariantGroupChangeOrderComponent implements OnInit {
    @Output() action = new EventEmitter();
    
    public originalTaskVariantGroups: any;
    
    public taskVariantGroups: any;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2
    ) { 
        this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
    }

    ok() {
        this.http.post("task_variant_groups/update_order", { task_variant_group_ids: this.taskVariantGroups.map(function(x) { return x.id; }) }).subscribe(() => {
            this.action.emit(true);
            this.bsModalRef.hide();
		});
    }

    cancel() {
        this.bsModalRef.hide();
    };

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.taskVariantGroups, event.previousIndex, event.currentIndex);
    }

    ngOnInit() {
        this.taskVariantGroups = JSON.parse(JSON.stringify(this.originalTaskVariantGroups));
    }
}
